<template lang="pug">
  .audit-quotation(v-loading="loading")
    title-bar {{ $t('报价') }}
    h3(style="margin-left: 20px") {{ data.sub_final_scope_name }}
    audit-sub-item-content(
      v-for="(item, i) in list"
      :data="item"
      :key="'table_data' + i"
      :parentIndex="i"
      :index="0"
      :disabledMarket='false'
      :showRejectBtn="false"
    )
    title-bar {{ $t('复核方案报价') }}
    div(v-if="isView" style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('审核结果') }}
        el-col(v-if="marketResult.status != null" :span="8") {{ $t(marketResult.status === 1 ? $t('通过') : $t('变更')) }} ( {{ marketResult.date | dateFormatter }} )
        el-col(v-else :span="8") —
      el-row
        el-col(:span="4") {{ $t('供应商') }}
        el-col(:span="12")
          span {{ log.vendor_name }}
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="6")
          display-text-container(:text="marketResult.status === 1 ? log.comment : log.reason")
    div(v-else style="margin-left: 20px")
      el-row
        el-col(:span="4") {{ $t('审核结果') }}
        el-col(:span="8")
          el-radio(v-model="audit" :label="1") {{ $t('通过 ') }}
          el-radio(v-model="audit" :label="2") {{ $t('变更') }}
      select-vendor-radio(
        :required="true"
        :data="list"
        v-if="audit === 2"
        @onChange="(val) => changedVendor = val"
        :defaultIndex="changedVendor"
      )
      el-row(
        v-if="audit === 2"
      )
        el-col(:span="4")
          .required {{ $t('备注') }}
        el-col(:span="6" style="position: relative")
          el-select(
            v-model="reason"
            filterable
            :placeholder="$t('请选择')"
            allow-create
            @change="handleChangeReason"
          )
            el-option(
              v-for="(item, i) in changeVendorReason"
              :key="i"
              :label="item.reason"
              :value="item.reason_id"
            )
      el-row(
        v-if="audit !== 2"
      )
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="6" style="position: relative")
          el-input(
            v-model="remark"
            type="textarea"
            :rows="8"
            style="width: 380px"
            :placeholder="$t('备注不多于500字')"
            :class="{'has-error': errors.has('remark_field') }"
            v-validate="'max:500'"
            data-vv-as="remark_field"
            name="remark_field"
          )
          p(class="input-error") {{ errors.first('remark_field') }}
    el-row(style="margin-left: 20px")
      el-col(
        :offset="4"
        :span="20"
      )
        footer-button(
          v-if="!isView"
          :confirmButtonDisabled="disableConfirmBtn"
          @confirm="onConfirm"
          @cancel="$router.push('/campaign/process')"
        )
    template(v-if="versions.length !== 0")
      title-bar {{ $t('历史版本') }}
      div(style="padding: 0 20px;margin-bottom: 50px;margin-top:20px")
        template(v-for="item in versions")
          audit-versions-item(:item = "item" :auditType="5")
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import FooterButton from '@/components/FooterButton'
import SendEmailDialog from '@/components/SendEmailDialog'
import QuotationList from '@/components/QuotationList'
import { flatten } from 'lodash'
import AuditVersionsItem from '@/components/AuditVersions/AuditVersionsItem'
import DisplayTextContainer from '@/components/DisplayTextContainer'
import SelectVendorRadio from '@/components/SelectVendorRadio'
import AuditSubItemContent from './ProcurementAuditSFSQuotationV3/AuditSubItemContent'
import { format4backend } from '@/umcc/util'

const getApproveHistory = (id, businessType, auditType) => {
  return axios.get('/management/subfinal/getApproveHistory', {
    params: {
      id: id,
      business_type: businessType,
      audit_type: auditType
    }
  })
}

export default {
  components: {
    FooterButton,
    TitleBar,
    SendEmailDialog,
    QuotationList,
    AuditVersionsItem,
    DisplayTextContainer,
    SelectVendorRadio,
    AuditSubItemContent
  },
  filters: {
    dateFormatter (str) {
      return str.replace(/-/gi, '/')
    }
  },
  data () {
    return {
      loading: true,
      audit: 1,
      remark: '',
      marketResult: {
        date: '',
        status: 0,
        comment: ''
      },
      list: [],
      versions: [],
      changeVendorReason: [],
      reason: {
        reason: '',
        reason_id: null
      },
      changedVendor: -1,
      data: {},
      log: {}
    }
  },
  computed: {
    campaign () {
      return this.$store.state.campaign
    },
    campaignId () {
      return this.$store.state.campaign.id
    },
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    },
    disableConfirmBtn () {
      if (this.audit === 1) return false
      if (this.audit === 2 && this.changedVendor !== -1) return false
      return true
    }
  },
  watch: {
    audit: {
      handler (nv, ov) {
        if (nv !== ov) {
          this.remark = ''
        }
      }
    }
  },
  mounted () {
    this.fetchQuotation()
    this.getChangeVendorReason()
    if (this.isView) {
      this.fetchMarketResult()
      this.getBusinessLog()
    }
  },
  methods: {
    getChangeVendorReason () {
      axios.get('/common/getChangeVendorReason')
        .then(res => {
          this.changeVendorReason = res
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    handleChangeReason (val) {
      if (typeof (val) !== 'string') return
      axios.get('/common/saveChangeVendorReason', {
        params: {
          reason: val
        }
      })
        .then(res => {
          this.reason = res
        })
    },
    // 获取报价
    fetchQuotation () {
      axios.get('/management/subfinal/v3/getVendorProgressForQuotationExt', {
        params: {
          sub_final_scope_id: this.subFinalScopeId
        }
      })
        .then(res => {
          this.loading = false
          this.data = res
          this.list = res.sub_final_scope_vendor
          this.getApproveHistory()
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    // 获取市场部审核报价结果
    fetchMarketResult () {
      axios.get('/management/subfinal/getApproveResult', {
        params: {
          id: this.campaign.subFinalScopeId,
          business_type: this.campaign.businessType,
          audit_type: 18
        }
      })
        .then(res => {
          this.loading = false
          this.marketResult = res
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    async onConfirm () {
      const validateResult = await this.$validator.validate()
      if (!validateResult) return
      this.loading = true
      try {
        await this.approve()
        await this.updateCampaignInfo()
        this.$emit('updateTab')
        this.$message.success(this.$t('提交成功'))
        if (this.audit === 1) {
          this.$store.commit('campaign/setPhaseType', 3)
        }
        this.$router.push('/campaign/process')
        this.loading = false
      } catch (err) {
        this.loading = false
        throw new Error(err)
      }
    },
    approve () {
      const params = {
        approve_result: this.audit,
        sub_final_scope_id: this.subFinalScopeId,
        task_id: this.$store.state.campaign.taskId,
        servlet_path: this.$route.path
      }
      if (this.audit === 2) {
        params.sub_final_scope_vendor_choice_advice = {
          reason_id: this.reason.reason_id,
          vendor_id: this.changedVendor
        }
      }
      return axios.post('/management/subfinal/v3/approveVendorPriceForMarketing', format4backend(params))
    },
    getCampaignOverview () {
      return axios.get('/management/campaign/getCampaignOverview', {
        params: { campaign_id: this.campaign.id }
      })
    },
    getSubFinalScope () {
      return axios.get('/management/subfinal/getSubFinalScopeList', {
        params: { campaign_id: this.campaign.id }
      })
    },
    async updateCampaignInfo () {
      this.loading = true
      const [res1, res2] = await Promise.all([this.getCampaignOverview(), this.getSubFinalScope()])
      this.$store.commit('campaign/setPhaseType', res1.phase_type)
      this.$store.commit('campaign/setBusinessType', res1.business_type)
      this.$store.commit('campaign/setOriginalBusinessType', res1.business_type)
      this.$store.commit('campaign/setSubFinalScopeId', res2[0].sub_final_scope_id)
      this.loading = false
    },
    getApproveHistory () {
      Promise.all(this.list.map(i => {
        return getApproveHistory(i.sub_final_scope_vendor_id, 4, 5)
      }).concat([getApproveHistory(this.data.sub_final_scope_id, 13, 19)]))
        .then(res => {
          this.versions = flatten(res).sort((a, b) => {
            return a.date < b.date ? 1 : -1
          })
        })
    },
    getBusinessLog () {
      axios
        .get('/common/getBusinessLog', {
          params: {
            servlet_path: this.$route.path,
            business_key: this.$store.state.campaign.subFinalScopeId
          }
        })
        .then(res => {
          this.log = res
        })
    }
  }
}
</script>

<style lang="stylus">
</style>
